<template>
  <b-row :class="{'almost-empty': vmVariant.inventoryQuantity < 10}">
    <b-col sm="6">
      <label>{{ variant.title }} <br><small>{{localizedCurrency(variant.price, currency) }} {{ !variant.title.includes('reserv') ? ' - für alle' : '' }}</small></label>
    </b-col>
    <b-col sm="4">
      <b-input-group size="sm" append="Einheiten">
        <b-form-input v-model="vmVariant.inventoryQuantity" style="min-width: 30px" type="number" min="0" size="sm"></b-form-input>
      </b-input-group>
    </b-col>
    <b-col sm="2">
      <label><b-button class="btn-sm" :variant="changed ? 'primary' : 'secondary'" @click="$emit('save-inventory', vmVariant)" :disabled="!changed"><i class="fas fa-save"></i></b-button></label>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: ['variant', 'currency'],
  data() {
    return {
      vmVariant: {}
    }
  },
  created() {
    this.vmVariant = {...this.variant}
  },
  computed: {
    changed() {
      return this.vmVariant.inventoryQuantity.toString() !== this.variant.inventoryQuantity.toString()
    },
  }
}
</script>
